import { useCallback } from 'react';

interface UseFileDownloadReturn {
  downloadFileAsBlob: (url: string, fileName: string) => Promise<boolean>;
}

export const useFileDownload = (): UseFileDownloadReturn => {
  const downloadFileAsBlob = useCallback(
    async (url: string, fileName: string): Promise<boolean> => {
      try {
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
        return true;
      } catch (error) {
        return false;
      }
    },
    []
  );

  return { downloadFileAsBlob };
};
